export const PDF_PAGE_HEIGHT = 1250;
export const PRODUCT_MIN_HEIGHT = 223